const adminWidgets = [
    'exchangesBalances',
    'exchangesBalancesRfq',
    'clientSearch',
    'clientSearchRfq',
];
export default adminWidgets;
